export const fallbackTag = { name: "", value: "" };
export const fallbackTypeaheadOption = { name: "", value: "" };
export const fallbackFiat = { name: "", value: "", rate: 0, sign: "" };
